module.exports = __webpack_public_path__ + "img/framework.90248f83.png";